import { useLocalStorageAsState } from "@msys/ui";
import { StoreType } from "./useExpandedStore.js";

export type EliminatedItemsStore = {
  areEliminatedItemsShown: boolean;
  setEliminatedItemsShown: (shown: boolean) => void;
};

function getDefaultShown(storeType: StoreType): boolean {
  return storeType === "quote-template";
}

export function useEliminatedItemsStoreWithLocalStorage(
  storeType: StoreType,
  docId: string
): EliminatedItemsStore {
  const [areEliminatedItemsShown, setEliminatedItemsShown] =
    useLocalStorageAsState<boolean>(
      `msys-show-eliminated-${storeType}-${docId}`,
      getDefaultShown(storeType),
      true
    );

  return { areEliminatedItemsShown, setEliminatedItemsShown };
}
